var _linearGradient, _path, _linearGradient2, _path2, _linearGradient3, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcons8Contacts(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    width: "64px",
    height: "64px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "QAzoyWpXxOdtGYT2BhOtLa",
    x1: 19,
    x2: 19,
    y1: 34.417,
    y2: 40.584,
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "reflect"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6dc7ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e6abff"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#QAzoyWpXxOdtGYT2BhOtLa)",
    d: "M24.81,37.5C23.35,39.04,21.29,40,19,40c-2.29,0-4.35-0.96-5.81-2.5 C14.65,35.96,16.71,35,19,35C21.29,35,23.35,35.96,24.81,37.5z"
  })), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "QAzoyWpXxOdtGYT2BhOtLb",
    x1: 19,
    x2: 19,
    y1: 26.583,
    y2: 33.425,
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "reflect"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6dc7ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e6abff"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#QAzoyWpXxOdtGYT2BhOtLb)",
    d: "M19 27A3 3 0 1 0 19 33A3 3 0 1 0 19 27Z"
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "QAzoyWpXxOdtGYT2BhOtLc",
    x1: 32,
    x2: 32,
    y1: 7.75,
    y2: 57.004,
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "reflect"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1a6dff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c822ff"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#QAzoyWpXxOdtGYT2BhOtLc)",
    d: "M57,29c0-1.654-1.346-3-3-3v-2c1.654,0,3-1.346,3-3s-1.346-3-3-3v-5c0-2.757-2.243-5-5-5h-1 c0-1.103-0.897-2-2-2h-4c-1.103,0-2,0.897-2,2H23c-2.757,0-5,2.243-5,5v7.051C11.85,20.562,7,25.72,7,32s4.85,11.438,11,11.949V51 c0,2.757,2.243,5,5,5h17c0,1.103,0.897,2,2,2h4c1.103,0,2-0.897,2-2h1c2.757,0,5-2.243,5-5v-3c1.654,0,3-1.346,3-3s-1.346-3-3-3v-2 c1.654,0,3-1.346,3-3s-1.346-3-3-3v-2C55.654,32,57,30.654,57,29z M23,10h17v9H28c-1.103,0-2,0.897-2,2v1.273 c-1.718-1.24-3.771-2.037-6-2.222V13C20,11.346,21.346,10,23,10z M28,24.089V21h12v6H29.895C29.405,25.936,28.765,24.958,28,24.089z M9,32c0-5.514,4.486-10,10-10s10,4.486,10,10s-4.486,10-10,10S9,37.514,9,32z M23,54c-1.654,0-3-1.346-3-3v-7.051 C26.15,43.438,31,38.28,31,32c0-1.038-0.146-2.039-0.395-3H40v2h-7v2h7v2h-7v2h7v2h-7v2h7v2H30v2h10v9H23z M55,29 c0,0.552-0.448,1-1,1v-2C54.552,28,55,28.448,55,29z M55,21c0,0.552-0.448,1-1,1v-2C54.552,20,55,20.448,55,21z M42,56V8h4l0.002,48 H42z M55,45c0,0.552-0.448,1-1,1v-2C54.552,44,55,44.448,55,45z M55,37c0,0.552-0.448,1-1,1v-2C54.552,36,55,36.448,55,37z M52,36v6 h-2v2h2v7c0,1.654-1.346,3-3,3h-1V10h1c1.654,0,3,1.346,3,3v5h-2v2h2v6h-2v2h2v6h-2v2H52z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8Contacts);
export default __webpack_public_path__ + "static/media/icons8-contacts.576241caea527ca2ec20e542340e2633.svg";
export { ForwardRef as ReactComponent };